module.exports = __webpack_public_path__ + "static/media/edit_1.9fea1e13.svg";